import { render, staticRenderFns } from "./login.vue?vue&type=template&id=fcf1ae48&scoped=true"
var script = {}
import style0 from "./login.vue?vue&type=style&index=0&id=fcf1ae48&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf1ae48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcf1ae48')) {
      api.createRecord('fcf1ae48', component.options)
    } else {
      api.reload('fcf1ae48', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=fcf1ae48&scoped=true", function () {
      api.rerender('fcf1ae48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/login.vue"
export default component.exports